var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"span",class:[_vm.baseCss, 'outline-none', _vm.rounded && _vm.ratio.replace(':', 'x') !== '4x3' ? 'bcq-flag-rounded' : '', _vm.flat ? null : ("shadow-" + _vm.elevation)],style:(_vm.style),attrs:{"to":_vm.to},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b0b4c5c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/bcq-ui/components/flag/flag.vue
// module id = null
// module chunks = 